module.exports = __webpack_public_path__ + "static/media/costcase10.16ccfe2f.png";